export default __webpack_public_path__ + "static/media/spec-typography-mobile.c57be002.png";